'use strict';

function UserModels({ client, fspId, modelId }) {

  return {
    returnModel: {
      name: 'userModel',
    },
    baseUrl: `/fsps/${fspId}/models/${modelId}/usermodels`,

    create: function create(data, queryParams, cb) {
      return client.executeRequest('POST', this.baseUrl, {
        data,
        queryParams,
        cb,
        returnModel: this.returnModel,
      });
    },
  };

}

module.exports = UserModels;
